import { cn } from '@1trading/react';
import type { ReactNode } from 'react';

/** Small uppercase label style shared by LabeledValue, stat tiles and group headings */
export const EYEBROW_CLASS = 'text-[11px] font-medium uppercase tracking-wide text-muted-foreground';

interface LabeledValueProps {
  label: string;
  children: ReactNode;
  /** Identifier-style values: break-all mono at 13px (the CardField/MetaField treatment) */
  mono?: boolean;
  className?: string;
}

/** Uppercase-label-over-value stack — the canonical CardField/MetaField styling. */
export const LabeledValue = ({ label, children, mono = false, className }: LabeledValueProps) => (
  <div className={cn('flex flex-col gap-0.5', className)}>
    <span className={EYEBROW_CLASS}>{label}</span>
    <span className={cn(mono && 'break-all font-mono text-[13px]')}>{children}</span>
  </div>
);
LabeledValue.displayName = 'LabeledValue';
